import {
  capitalizeFirstLetter,
  formatDateOnly,
  isFieldEmptyAndInOverview
} from 'utils/helpers';
import {
  ValidationSet,
  userProfileRegisterApplicantI
} from '../../../../../types/interface';
import { federal_state, sap_agree_radio } from 'utils/staticData';
import { StandardRadio } from 'base/StandardRadio/StandardRadio';
import {
  EARLY_RETIREMENT,
  INTERNAL_EMPLOYEE,
  LEASING_AND_PAYROLLING,
  SAP_AGREE,
  SAP_DISAGREE
} from 'utils/enums/misc';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import StandardCheckbox from 'base/StandardCheckbox/StandardCheckbox';
import { t } from 'i18next';
import StandardInput from 'base/StandardInput/StandardInput';
import StandardSelect from 'base/StandardSelect/StandardSelect';
import { StandardImageUpload } from 'base/StandardImageUpload/StandardImageUpload';
import { DataNotFound } from 'base/DataNotFound/DataNotFound';
import StandardPhoneNumber from 'base/StandardPhoneNumber/StandardPhoneNumber';

export const RegisterApplicant = ({
  data
}: {
  data: userProfileRegisterApplicantI;
}) => {
  const disabled = true;
  const showError = false;
  const onChange = () => {};
  const userProfileRegisterApplicantValidationSets: ValidationSet<userProfileRegisterApplicantI> =
    {
      maternity_leave: [],
      sap_agree: [],
      sap_disagree: [],
      term_of_use: [],
      first_name: [],
      last_name: [],
      personnel_number: [],
      email: [],
      street: [],
      location_private: [],
      federal_state: [],
      birth_date: [],
      employed_since: [],
      iban_applicant: [],
      bic_applicant: [],
      registration_form_file: [],
      proof_of_employement_file: [],
      proof_of_last_entry_file: [],
      account_name: []
    };
  return (
    <div id="user_profile_register_applicant">
      <div className="container-fluid px-0 ">
        <ConditionalRender condition={!!data} fallBack={<DataNotFound />}>
          <div className="row ">
            <div className="col-12 title text-center">
              <h1 className="my-3">
                {capitalizeFirstLetter(t('register_applicant.heading'))}
              </h1>
            </div>
            <ConditionalRender
              condition={data?.user_type === INTERNAL_EMPLOYEE}
            >
              <StandardCheckbox
                isChecked={data?.user_type === INTERNAL_EMPLOYEE}
                setChecked={() => {}}
                className="checkbox-margin-class"
                label={t('register_applicant.radioButtons1.label_1')}
                disabled={disabled}
              />
            </ConditionalRender>
            <ConditionalRender condition={data?.user_type === EARLY_RETIREMENT}>
              <StandardCheckbox
                isChecked={data?.user_type === EARLY_RETIREMENT}
                setChecked={() => {}}
                className="checkbox-margin-class"
                label={t('user.option.label_2')}
                disabled={disabled}
              />
            </ConditionalRender>
            <ConditionalRender
              condition={data?.user_type === LEASING_AND_PAYROLLING}
            >
              <StandardCheckbox
                isChecked={data?.user_type === LEASING_AND_PAYROLLING}
                setChecked={() => {}}
                className="checkbox-margin-class"
                label={t('register_applicant.radioButtons2.label_1')}
                disabled={disabled}
              />
            </ConditionalRender>
            <ConditionalRender condition={data?.user_type !== EARLY_RETIREMENT}>
              <div className="row pb-2 pt-1">
                <div className="col-12">
                  <StandardCheckbox
                    isChecked={data?.maternity_leave}
                    setChecked={() => {}}
                    className="checkbox-margin-class"
                    label={t('register_applicant.radioButtons3.label_1')}
                    disabled={disabled}
                  />
                </div>
              </div>
            </ConditionalRender>
            <div className="col-12 col-md-6" id="left_side_form">
              <div className="row">
                <StandardInput
                  id="first-name-common"
                  type="text"
                  className="form-control-icon col-12"
                  placeholder={t('general.common_text.text_5')}
                  label={t('general.common_text.text_5')}
                  value={data.first_name}
                  showError={showError}
                  disabled={disabled}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.first_name
                  }
                />
                <StandardInput
                  type="text"
                  className="form-control-icon col-12"
                  placeholder={t('general.common_text.text_6')}
                  label={t('general.common_text.text_6')}
                  value={data.last_name}
                  showError={showError}
                  disabled={disabled}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.last_name
                  }
                />
              </div>
              <div className="row">
                <StandardInput
                  type="text"
                  className="form-control-icon col-12"
                  placeholder={t(
                    'register_applicant.placeholder.personnelNumber'
                  )}
                  value={data.personnel_number || '00'}
                  showError={showError}
                  onChange={onChange}
                  disabled={disabled}
                  maxLength={8}
                  validations={
                    userProfileRegisterApplicantValidationSets.personnel_number
                  }
                  label={t('register_applicant.placeholder.personnelNumber')}
                />
                <StandardInput
                  type="text"
                  className="form-control-icon col-12  "
                  placeholder={t('general.common_text.text_4')}
                  value={data.email}
                  showError={showError}
                  onChange={onChange}
                  validations={userProfileRegisterApplicantValidationSets.email}
                  disabled={true}
                  label={t('general.common_text.text_4')}
                />
                <StandardInput
                  type="text"
                  className="form-control-icon col-12"
                  placeholder={t('application.placeholder.account_name')}
                  value={data.account_name}
                  showError={showError}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.account_name
                  }
                  disabled={true}
                  label={t('application.placeholder.account_name')}
                />
              </div>
            </div>
            <div className="col-12 col-md-6" id="right_side_form">
              <div className="row">
                <StandardInput
                  type="text"
                  className="form-control-icon col-12"
                  placeholder={t('register_applicant.placeholder.street')}
                  label={t('register_applicant.placeholder.street')}
                  value={data.street}
                  showError={showError}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.street
                  }
                  disabled={disabled}
                />
              </div>
              <div className="row">
                <StandardInput
                  type="number"
                  className="form-control-icon col-12 col-lg-4"
                  placeholder={t('register_applicant.placeholder.zip')}
                  label={t('register_applicant.placeholder.zip')}
                  showError={showError}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.zip_code_private!
                  }
                  disabled={disabled}
                  value={data.zip_code_private as number}
                />
                <StandardInput
                  type="text"
                  className="form-control-icon col-12 col-lg-4"
                  placeholder={t('register_applicant.placeholder.location')}
                  label={t('register_applicant.placeholder.location')}
                  value={data.location_private}
                  showError={showError}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.location_private
                  }
                  disabled={disabled}
                />
                <StandardSelect
                  value={
                    data.federal_state
                      ? data.federal_state?.toLowerCase()
                      : null
                  }
                  onChange={onChange}
                  name={'federal_state'}
                  placeholder={t('register_applicant.placeholder.federalState')}
                  label={t('register_applicant.placeholder.federalState')}
                  className={'col-12 col-lg-4'}
                  options={federal_state}
                  showError={showError}
                  isMulti={false}
                  validations={
                    userProfileRegisterApplicantValidationSets.federal_state
                  }
                  disabled={disabled}
                  formClassName=""
                  id=""
                  formGroupClassName="col-12 col-lg-4"
                />
              </div>
              <div className="row">
                <StandardInput
                  className="form-control-icon col-12 col-md-6"
                  placeholder={t('register_applicant.placeholder.birthDate')}
                  value={formatDateOnly(data.birth_date)}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.birth_date
                  }
                  disabled={disabled}
                  showError={showError}
                  label={t('register_applicant.placeholder.birthDate')}
                  type=""
                />
                <StandardInput
                  placeholder={t(
                    'register_applicant.placeholder.employed_since'
                  )}
                  value={formatDateOnly(data.employed_since)}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.employed_since
                  }
                  disabled={disabled}
                  showError={showError}
                  label={t('register_applicant.placeholder.employed_since')}
                  className="col-12 col-md-6"
                  type=""
                />
              </div>
              <div className="row">
                <StandardPhoneNumber
                  className=""
                  onChange={onChange}
                  showError={showError}
                  value={data.telephone_number || ''}
                  placeholder={t('register_applicant.placeholder.phoneNumber')}
                  disabled={disabled}
                  validations={
                    userProfileRegisterApplicantValidationSets.telephone_number!
                  }
                  label={t('register_applicant.placeholder.phoneNumber')}
                />
              </div>
              <div className="row">
                <StandardInput
                  type="text"
                  className="form-control-icon col-12 col-md-6"
                  placeholder={t('register_applicant.placeholder.IBAN')}
                  label={t('register_applicant.placeholder.IBAN')}
                  value={data.iban_applicant}
                  showError={showError}
                  disabled={disabled}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.iban_applicant
                  }
                  doNotCapitalize
                />
                <StandardInput
                  type="text"
                  className="form-control-icon col-12 col-md-6"
                  placeholder={t('register_applicant.placeholder.BIC')}
                  label={t('register_applicant.placeholder.BIC')}
                  value={data.bic_applicant}
                  disabled={disabled}
                  showError={showError}
                  onChange={onChange}
                  validations={
                    userProfileRegisterApplicantValidationSets.bic_applicant
                  }
                  doNotCapitalize
                />
              </div>
              <div className="row">
                <StandardImageUpload
                  className="mb-2"
                  value={data?.registration_form_file}
                  disabled={!disabled}
                  imageText={t(
                    'basic_data.without_income.left.attachment.text_1'
                  )}
                  validations={
                    userProfileRegisterApplicantValidationSets?.registration_form_file
                  }
                  showError={showError}
                  label={t('basic_data.without_income.left.attachment.text_1')}
                />
              </div>
              <div className="row">
                <StandardRadio
                  options={sap_agree_radio}
                  disabled={disabled}
                  onChange={() => {}}
                  value={data.sap_agree ? SAP_AGREE : SAP_DISAGREE}
                  className="mb-2 text-black"
                  showError={showError}
                  validations={
                    userProfileRegisterApplicantValidationSets.sap_aggress
                  }
                />
              </div>
              <div className="row">
                <StandardImageUpload
                  value={data.proof_of_employement_file}
                  disabled={!disabled}
                  imageText={t('register_applicant.general.attachment.text_1')}
                  validations={
                    data.sap_disagree
                      ? userProfileRegisterApplicantValidationSets.proof_of_employement_file
                      : []
                  }
                  showError={data.sap_disagree && showError}
                  label={t('register_applicant.general.attachment.text_1')}
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!data.proof_of_employement_file
                  )} col-12 col-md-6`}
                />
                <StandardImageUpload
                  value={data.proof_of_last_entry_file}
                  disabled={!disabled}
                  imageText={t('register_applicant.general.attachment.text_2')}
                  showError={data.sap_disagree && showError}
                  validations={
                    data.sap_disagree
                      ? userProfileRegisterApplicantValidationSets?.proof_of_last_entry_file
                      : undefined
                  }
                  label={t('register_applicant.general.attachment.text_2')}
                  className={`${isFieldEmptyAndInOverview(
                    true,
                    !!data.proof_of_last_entry_file
                  )} col-12 col-md-6`}
                />
              </div>
            </div>
          </div>
        </ConditionalRender>
      </div>
    </div>
  );
};
